import { App } from './app.class';
import { Fetch } from '../fetch.class';
import Upgrademodal from './upgrademodal.class';
import * as Sqrl from 'squirrelly';
import { Notification } from './notification.class';

export class Notificationsmenu {

    // Init
    constructor() {

        this.$popup = null;
        this.$btn = null;
        this.$cont = null;
        this.$emptyState = null;
        this.btnAnimation = null;
        this.intervalLoadEntries = null;
        this.tplNotifications = null;

        // DOM ready
        App.domready(() => {

            // Elemente
            this.$popup = document.querySelector(".topbar .popup.notifications");
            if(!this.$popup) {
                return;
            }
            this.$btn = this.$popup.querySelector("#notifications-menu");
            this.$cont = this.$popup.querySelector(".popup-display .cont");
            this.$emptyState = this.$popup.querySelector(".popup-display .empty-state");

            // Klick auf Glocken-Button
            this.$btn.addEventListener("click", event => {

                // Progressbars animieren
                this.#animateProgressbars();
            });

            // nach 1,5 Sek. Einträge laden
            setTimeout(() => {
                this.loadEntries();
            }, 1500);

            // Template für Notifications
            const $tplNotifications = this.$cont.querySelector('#tpl_notifications');
            if($tplNotifications) {
                this.tplNotifications = Sqrl.compile( $tplNotifications.innerHTML );
            }

            // Link-Handler
            this.$cont.addEventListener('click', event => {
                if(event.target) {

                    // Upgrade-Links
                    const $btn_upgrade = event.target.closest('a.upgrade');
                    if($btn_upgrade) {
                        event.preventDefault();

                        // Notifications schliessen
                        window.Popups.forEach(popup => {
                            popup.close();
                        });

                        // Upgrade-Modal
                        const successMsg = $btn_upgrade.dataset.successmsg ?? '';
                        const upgradetype = $btn_upgrade.dataset.upgradetype ?? '';
                        Upgrademodal.open(
                            () => {

                                // Erfolgsmeldung
                                new Notification().success("Upgrade", successMsg);

                                // Notifications neu laden
                                this.loadEntries();
                            },
                            upgradetype
                        );
                    }

                    // Resend Account Activation Message
                    const $btn_resendactivation = event.target.closest('a.resend_accountactivation');
                    if($btn_resendactivation) {
                        event.preventDefault();

                        // Notifications schliessen
                        window.Popups.forEach(popup => {
                            popup.close();
                        });

                        // Aktivierungmail neu senden
                        new Fetch().get(App.getUrl('account', 'resendconfirmmail'))
                        .then(response => {

                            // Erfolgsmeldung
                            new Notification().success(response.message_header, response.message_text);
                        })
                        .catch(error => {

                            // Fehlermeldung
                            new Notification().error(error.message);
                        });
                    }
                }
            });
        });
    }

    // Button-Animation abspielen
    #playBtnAnimation() {

        // läuft bereits
        if(this.btnAnimation)
            return;

        if(this.$btn) {

            const $img = this.$btn.querySelector("img");

            // Ensure proper transform behavior
            $img.style.transformBox = "fill-box";
            $img.style.transformOrigin = "50% 12%";
            $img.style.transform = "rotate(0deg)";

            // Animation ausführen
            this.btnAnimation = $img.animate(
                [
                    { transform: "rotate(0deg)" },
                    { transform: "rotate(-20deg)" },
                    { transform: "rotate(20deg)" },
                    { transform: "rotate(-15deg)" },
                    { transform: "rotate(15deg)" },
                    { transform: "rotate(-15deg)" },
                    { transform: "rotate(10deg)" },
                    { transform: "rotate(-10deg)" },
                    { transform: "rotate(0deg)" }
                ],
                {
                    duration: 1800,
                    easing: "ease-out",
                    iterations: 1
                }
            );

            this.btnAnimation.onfinish = () => {
                $img.style.transform = "rotate(0deg)";
                this.btnAnimation = null;
            };
        }
    }

    // Progressbars animieren
    #animateProgressbars() {
        const progressbars = document.querySelectorAll(".topbar .popup.notifications .popup-display .progressbar");
        progressbars.forEach($progressbar => {
            if($progressbar.hasAttribute("data-percent")) {

                const percent = parseInt($progressbar.dataset.percent);
                const $bar = $progressbar.firstElementChild.firstElementChild;

                const $li = $progressbar.closest("li");
                let isWarning = $li.classList.contains("warning");

                // erst auf 0 setzen
                $bar.classList.add("notrans");
                $bar.style.width = "0%";
                $bar.style.backgroundColor = "#3B82F6";
                setTimeout(() => {

                    // Zielwert
                    $bar.classList.remove("notrans");
                    $bar.style.width = percent+"%";
                    if(isWarning) {
                        $bar.style.backgroundColor = "#EF4444";
                    }
                }, 10);
            }
        });
    }

    // Laden der Einträge
    loadEntries() {

        new Fetch().get(App.getUrl('account', 'get_notifications'))
        .then(response => {

            this.$btn.classList.remove("show-indicator");

            // Einträge geliefert
            if(response.notifications && response.notifications.length > 0) {

                this.$emptyState.classList.add("hidden");

                // Inhalt aus Template einfügen
                this.$cont.innerHTML = this.tplNotifications(response, Sqrl.defaultConfig);

                // Indicator?
                let showIndicator = false;
                response.notifications.forEach(notification => {
                    if(notification.show_indicator && notification.show_indicator == true) {
                        showIndicator = true;
                    }
                });
                if(showIndicator) {
                    this.$btn.classList.add("show-indicator");
                    this.#playBtnAnimation();
                }

                // Progressbars animieren wenn Notifications geöffnet
                if(this.$popup.classList.contains("open")) {
                    this.#animateProgressbars();
                }
            }

            // keine Einträge
            else {
                this.$emptyState.classList.remove("hidden");
            }

            // regelmässig neu laden
            if(this.intervalLoadEntries == null) {
                this.intervalLoadEntries = setInterval(this.reloadEntries.bind(this), 30000); // 30 Sek.
            }
        })
        .catch(error => {
            console.error(error.message);
        });
    }

    // Neuladen der Einträge
    reloadEntries() {

        // nur wenn Notifications nicht geöffnet sind
        if(!this.$popup.classList.contains("open")) {
            this.loadEntries();
        }
    }

}